import { IconName } from '@/core'
import { FooterNavListType, FooterNavSecType, StatsType } from '@/types'

export const PARTNER_LIST: IconName[] = ['market-watch', 'market-insider', 'morning-star', 'yahoo', 'benzinga']

export const ABOUT_STATS: StatsType[] = [
  {
    count: 157,
    title: 'Success Projects'
  },
  {
    count: 120,
    title: 'Happy Clients'
  },
  {
    count: 30,
    title: 'Active Clients'
  },
  {
    count: 7,
    title: 'Experience'
  }
]

export const FOOTER_NAV_LIST: FooterNavListType = {
  pages: ['home', 'project', 'about'],
  'utility pages': ['contact', 'skills', 'feedback']
}

export const FOOTER_NAV_TYPE_LIST: FooterNavSecType[] = ['pages', 'utility pages']
